
import { RouteObject } from "react-router-dom";
import HomePage from "../pages/home/page";
import AboutPage from "../pages/about/page";
import SkillsPage from "../pages/skills/page";
import ExperiencePage from "../pages/experience/page";
import SideProjectsPage from "../pages/side-projects/page";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/skills",
    element: <SkillsPage />,
  },
  {
    path: "/experience",
    element: <ExperiencePage />,
  },
  {
    path: "/side-projects",
    element: <SideProjectsPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
